import React from 'react';
import LazyLoad from "react-lazyload";
import {isBot} from "../../libs/helper";

const Image = (props) => {
    return isBot ? <img {...props} alt={props.alt || props.src}/> : (
        <LazyLoad>
            <img {...props} alt={props.alt || props.src} />
        </LazyLoad>
    )
};

export default Image;
